import React from 'react';
import { Link } from 'react-router-dom';
import { useParallax } from 'react-scroll-parallax';

// Assets
const OCTOPUS = 'https://santaplaya-bucket.s3.amazonaws.com/Octopus.webp';
const FISH_SCHOOL =
  'https://santaplaya-bucket.s3.amazonaws.com/fish_school.webp';
const BUBBLES_BLUE =
  'https://santaplaya-bucket.s3.amazonaws.com/bubbles_blue.webp';
const CAMARON_COCKTAIL =
  'https://santaplaya-bucket.s3.amazonaws.com/Camaron_Cocktail.webp';
const TOSTADA_FULL =
  'https://santaplaya-bucket.s3.amazonaws.com/tostada_full.webp';

const HeroSection: React.FC = () => {
  // Provide the generic `HTMLImageElement`
  const ref = useParallax<HTMLImageElement>({
    rotate: [0, 20],
  });

  const ref1 = useParallax<HTMLImageElement>({
    translateY: [100, -100],
  });

  const ref2 = useParallax<HTMLImageElement>({
    translateX: [10, -25],
  });

  return (
    <section
      className="
        relative
        w-full
        min-h-[50vh]
        md:min-h-[80vh]
        flex
        bg-white
        overflow-visible
      "
    >
      {/* --- TOP-LEFT TEXT --- */}
      <div
        className="
          absolute
          top-[10%]
          left-4
          md:top-[15%]
          md:left-[5%]
          z-20
        "
      >
        <h1 className="font-charles text-maroon text-3xl md:text-5xl leading-tight">
          FRESH MEXICAN SEAFOOD
        </h1>
        <p className="font-prosto text-maroon text-base md:text-xl mt-2 font-thin">
          WITH A BAJA TWIST IN SANTA BARBARA
        </p>

        <div className="flex flex-row justify-start md:justify-center items-center space-x-4 md:space-x-8 mt-6">
          <Link
            to="/menu"
            className="bg-sea text-white rounded-full py-2 px-6 md:py-3 md:px-8 font-prosto text-xs md:text-sm"
          >
            View Menu
          </Link>
          <Link
            to="/order"
            className="bg-sea text-white rounded-full py-2 px-6 md:py-3 md:px-8 font-prosto text-xs md:text-sm"
          >
            Order Online
          </Link>
        </div>
      </div>

      {/* --- OCTOPUS (TOP-RIGHT) --- */}
      <img
        src={OCTOPUS}
        alt="Octopus Accent"
        className="
          absolute
          md:-top-[20%]
          right-0
          w-[45vw]
          max-w-[400px]
          md:max-w-[600px]
          z-10
        "
      />

      {/* --- FISH SCHOOL (BOTTOM-LEFT-ish) --- */}
      <img
        src={FISH_SCHOOL}
        ref={ref2.ref}
        alt="Fish School Accent"
        className="
          absolute
          -bottom-[20%]
          left-0
          w-[70vw]
          max-w-[500px]
          md:max-w-[1000px]
          z-10
        "
      />

      {/* --- BUBBLES (BOTTOM-RIGHT) --- */}
      <img
        src={BUBBLES_BLUE}
        ref={ref1.ref}
        alt="Bubbles Blue Accent"
        className="
          absolute
          bottom-0
          right-[10%]
          w-[15vw]
          max-w-[150px]
          md:max-w-[180px]
          z-10
        "
      />

      {/* --- CAMARON COCKTAIL (MID-RIGHT) --- */}
      <img
        src={CAMARON_COCKTAIL}
        alt="Camaron Cocktail"
        className="
          absolute
          bottom-[20%]
          md:top-[30%]
          right-0
          w-[35vw]
          max-w-[300px]
          md:max-w-[500px]
          z-20
          -translate-y-1/2
        "
      />

      {/* --- TOSTADA (CENTER/BOTTOM) with Parallax ref --- */}
      <img
        src={TOSTADA_FULL}
        alt="Tostada"
        ref={ref.ref}
        className="
          absolute
          bottom-[10%]
          left-1/2
          w-[45vw]
          max-w-[420px]
          md:max-w-[600px]
          z-20
          transform
          -translate-x-1/2
        "
      />
    </section>
  );
};

export default HeroSection;
